// extracted by mini-css-extract-plugin
export default {"root":"Manufacturer_root__6EnQy","header":"Manufacturer_header__FLGV3","body":"Manufacturer_body__h3IhD"};